import { schemes, zSchema } from "@zeal/common";

export const postRetryTransactionRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  transactionID: schemes.uuid(),
  bankAccountID: schemes.mongoOrUuid(),
});

export type TPostRetryTransactionRequest = zSchema.infer<
  typeof postRetryTransactionRequestSchema
>;
